import React, { useEffect, useState } from "react";
import styles from "./EventDetails.module.css";
import { Chip, Typography, Avatar, Stack, useMediaQuery, CircularProgress } from "@mui/material";
import strings from "../../../strings/Strings";
import ImageAssets from "../../../assets";
import useWindowDimensions from "../../../custom/useWindowDimensions";
import { MuiTextField } from "../../../components/common/textfield/MuiTextField";
import { MuiButton } from "../../../components/common/button/MuiButton";
import { useNavigate, useParams } from "react-router-dom";
import { getCookies } from "../../../utils/Cookies";
import { useDispatch, useSelector } from "react-redux";
import { createRazorpayOrderRequest, getRefundRequest, registerUserForEventsRequest, setEventState, verifyPromoCodeRequest } from "../../../redux/events-redux/EventsRedux";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import { setError } from "../../../redux/toaster-redux/ToasterRedux";
import RefundPolicy from "./RefundPolicy";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import CustomSuccessDailog from "../../../components/common/dailog/success-dailog/MuiSuccessDailog";
import { DailogBoxTypeEnum } from "../../../core/enumerations/DailogBoxTypeEnum";
import constants from "../../../core/constants/Constants";

const EventDetailsPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isMobile = useMediaQuery("(max-width: 839px)");

    const { success, orderCreated, data, orderId, promoCodeAmount, promoCodeVerified, appliedRefund, promoCodeError, showRefundPopup } = useSelector((state: any) => state.events);

    const [promoCode, setPromoCode] = useState("");
    const [refundPopup, setRefundPopup] = useState(false);
    const [infoPopup, setInfoPopup] = useState(false);
    const { screenSize } = useWindowDimensions();
    const [expand, setExpand] = useState(false);
    const [readMore, setReadMore] = useState(false);
    const [eventData, setEventData] = useState<any>({ eventImage: "", eventName: "", eventType: '', registeredUser: false, registeredUsers: [], appliedRefund: false });

    const { id } = useParams();
    const userDetails = getCookies("userDetails");
    const loggedInUser: any = JSON.parse(userDetails);

    console.log(promoCodeError, "promoCodeError", success, orderCreated)

    const getShortDescription = (htmlString) => {
        const div = document.createElement("div");
        div.innerHTML = htmlString;
        return div.textContent || div.innerText || "";
    };

    const plainText = getShortDescription(eventData?.description || "");
    const isLong = plainText.length > 100;

    const displayedHtml = readMore || !isLong
        ? eventData?.description
        : `${plainText.slice(0, 100)}...`;

    useEffect(() => {
        if (success) {

            setTimeout(() => {
                window.location.reload();
            }, constants.threeSeconds);

            let event = eventData;
            setEventData({
                ...event, registeredUser: true,
                noOfFilledSpots: event?.noOfFilledSpots + 1,
                registeredUsers: [
                    {
                        profilePic: loggedInUser?.profilePic,
                        userName: loggedInUser?.userName,
                        fullName: loggedInUser?.fullName
                    },
                    ...(event?.registeredUsers || []),
                ]
            })
            setPromoCode('');
            dispatch(setEventState({
                key: "success",
                value: false
            }))
            dispatch(setEventState({
                key: "orderCreated",
                value: false
            }))

        }
    }, [success])

    useEffect(() => {
        if (appliedRefund) {

            setTimeout(() => {
                window.location.reload();
            }, constants.threeSeconds);

            let event = eventData;
            setEventData({
                ...event, appliedRefund: true,
            })
            setPromoCode('');
            dispatch(setEventState({
                key: "appliedRefund",
                value: false
            }))
        }
    }, [appliedRefund])

    const fetchEventById = async () => {
        const apiResponse = await fetch(`${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/event/get/details/${id}?userId=${loggedInUser?.id}`,
            {
                headers: {
                    Authorization: getLocalStorageItem("token")
                }
            }
        );
        const response = await apiResponse.json();
        const data = response?.data;
        setEventData({ ...data });
    }

    useEffect(() => {
        fetchEventById();
    }, [])

    const handleRegister = () => {
        if (promoCodeVerified && promoCodeAmount === 0) {
            const payload: any = { eventId: id, userId: loggedInUser?.id, amount: 0, promocode: promoCode || '', data: {} }
            dispatch(registerUserForEventsRequest(payload));
        }
        else {
            const payload: any = { eventId: id, userId: loggedInUser?.id, amount: '', promocode: '' || '', data: {} }
            dispatch(registerUserForEventsRequest(payload));
        }
    }

    const handlePayBtn = () => {
        const receipt = `order_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
        const payload: any = { amount: Math.round(eventData.amount), receiptId: receipt, eventId: id, promocode: promoCode }
        dispatch(createRazorpayOrderRequest(payload));
    }

    const handleVerifyPayment = (response: any) => {
        const payload: any = {
            eventId: id,
            userId: loggedInUser?.id,
            amount: promoCodeAmount || eventData?.amount || 0,
            promocode: promoCode || '',
            data: {
                razorpayPaymentId: response?.razorpay_payment_id,
                razorpayOrderId: response?.razorpay_order_id,
                razorpaySignature: response?.razorpay_signature,
            }
        }
        dispatch(registerUserForEventsRequest(payload));
    }

    const handleRazorpayPopup = () => {
        console.log(orderId, "orderId", data?.id)
        const options = {
            key: process.env.REACT_APP_SEKERON_DEV_MODE === "Prod" ? process.env.RAZORPAY_LIVE_KEY_ID : process.env.RAZORPAY_TEST_KEY_ID, // Replace with your Razorpay key
            // amount: Math.round(eventData.amount), // in paise (e.g., 50000 = ₹500)
            currency: "INR",
            name: "Sekeron",
            description: "Purchase Description",
            image: "/your-logo.png", // Optional
            order_id: orderId || data?.id, // <-- Razorpay order_id from backend
            handler: async function (response) {
                // ✅ Send response.razorpay_payment_id and response.razorpay_order_id to backend for verification
                console.log(response, "response")
                handleVerifyPayment(response);
                // await fetch("/your-backend-api/verify-payment", {
                //     method: "POST",
                //     headers: { "Content-Type": "application/json" },
                //     body: JSON.stringify({
                //         razorpay_payment_id: response.razorpay_payment_id,
                //         razorpay_order_id: response.razorpay_order_id,
                //         razorpay_signature: response.razorpay_signature,
                //     }),
                // });
            },
            prefill: {
                name: loggedInUser.userName,
                // email: loggedInUser.email || '',
                // contact: loggedInUser.email || '',
            },
            theme: {
                color: "#3399cc",
            },
        };

        const RazorpayConstructor = (window as any).Razorpay;
        const paymentObject = new RazorpayConstructor(options);
        paymentObject.open();
    }

    useEffect(() => {
        if (orderCreated) {
            handleRazorpayPopup();
        }
    }, [orderCreated])

    const handleVerifyPromoCode = () => {
        const payload: any = {
            eventId: id,
            promocode: promoCode
        }
        const response = {
            status: 500,
            data: { message: "Please enter promo code" },
        }
        if (promoCode) {
            dispatch(verifyPromoCodeRequest(payload));
        }
        else {
            dispatch(setError(response));
        }
    }

    const isFree = eventData?.eventType === "FREE";
    const isPromoFree = promoCodeVerified && promoCodeAmount === 0;
    const showRegister = isFree || isPromoFree;

    const handleRefundBtn = () => {
        const payload: any = { userId: loggedInUser?.id, eventId: id, refundReason: '' }
        dispatch(getRefundRequest(payload));
        setRefundPopup(false);
    }

    const handleProfileRedirection = (userId: any) => {
        navigate(`/profile/others-profile/${userId}`);
    }

    const handleCloseRefundPopup = () => {
        dispatch(setEventState({
            key: "showRefundPopup",
            value: false
        }))
    }

    return (
        <>
            <div className={styles["container"]}>
                {/* //top event banner image */}
                <div className={styles["sub-container-two"]}>
                    <Stack className={styles["header"]}>
                        <ArrowBackIosNewRoundedIcon onClick={() => navigate(-1)} />
                        <Typography style={{ fontSize: '1.6rem' }} >Events</Typography>
                    </Stack>
                    <img src={isMobile ? eventData?.eventMobileImage : eventData?.eventImage || "https://images.unsplash.com/photo-1483794344563-d27a8d18014e"}
                        alt="Event Banner"
                        className={styles["event-image"]}
                    />
                </div>

                <div className={styles["sub-container-one"]}>
                    <Stack className={styles["event-title"]}>
                        <Typography>{eventData?.eventName}</Typography>
                        {isMobile ? null :
                            <>
                                <Chip
                                    label={eventData?.eventType}
                                    color="success"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        height: 28,
                                        width: 62,
                                        backgroundColor: '#45645C',
                                        borderColor: '#45645C',
                                        color: 'white',
                                        borderRadius: '3.2rem',
                                        '& .MuiChip-label': {
                                            fontSize: '14px',
                                            color: 'white',
                                        },
                                    }}
                                />
                                {eventData?.eventType === "FREE" ? null :
                                    <img src={ImageAssets.ic_info} style={{ cursor: 'pointer' }} onClick={() => {
                                        setRefundPopup(true)
                                        setInfoPopup(true)
                                    }} />
                                }
                            </>
                        }
                    </Stack>

                    <Stack flexDirection={"column"} gap={1} className={styles["event-details"]}>
                        <Typography>Hosted by Sekeron</Typography>
                        {isMobile ?
                            <Stack gap={1} alignItems={'center'}>
                                <Chip
                                    label={eventData?.eventType}
                                    color="success"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        height: 29,
                                        width: 54,
                                        backgroundColor: '#45645C',
                                        borderColor: '#45645C',
                                        color: 'white',
                                        borderRadius: '3.2rem',
                                        '& .MuiChip-label': {
                                            fontSize: '12px',
                                            color: 'white',
                                        },
                                    }}
                                />
                                {eventData?.eventType === "FREE" ? null :
                                    <img src={ImageAssets.ic_info} style={{ cursor: 'pointer', height: '2.4rem' }} onClick={() => {
                                        setRefundPopup(true)
                                        setInfoPopup(true)
                                    }} />
                                }
                            </Stack>
                            : ''
                        }

                        <div className={styles["line-break"]}></div>

                        {/* //event details like date/time , meeting link, event type etc */}
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            alignItems={{ xs: 'flex-start', sm: 'center' }}
                            justifyContent="space-between"
                            gap={2}
                        >
                            {/* Right side (Chips) - On mobile this will appear first */}
                            {/* <Stack
                                direction="row"
                                gap={2}
                                order={{ xs: 1, sm: 2 }}
                            // alignSelf={{ xs: 'center', sm: 'auto' }}
                            >
                                <Chip
                                    label={eventData?.eventType}
                                    color="success"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        height: 30,
                                        width: 80,
                                        backgroundColor: 'success.main',
                                        borderColor: 'success.main',
                                        color: 'black',
                                        borderRadius: '1rem',
                                        '& .MuiChip-label': {
                                            fontSize: '14px',
                                            color: 'black',
                                        },
                                    }}
                                />
                            </Stack> */}

                            {/* Left side (Event details) */}
                            <Stack flexDirection="column" order={{ xs: 2, sm: 1 }} gap={1}>
                                <Stack alignItems="center" columnGap={isMobile ? 1.5 : 1} direction="row">
                                    <img
                                        src={ImageAssets.calendar}
                                        className={styles["date-picker-icon"]}
                                        alt="date picker"
                                        style={{ height: isMobile ? '' : '1.8rem', width: isMobile ? '' : '1.8rem' }}
                                    />
                                    <Typography className={styles["event-date"]}>
                                        {new Date(eventData?.eventDate).toLocaleDateString()} | {new Date(eventData?.eventDate).toLocaleTimeString()}
                                    </Typography>
                                </Stack>

                                <Stack alignItems="center" columnGap={isMobile ? 1.5 : 1} direction="row">
                                    <img
                                        src={ImageAssets.ic_location}
                                        className={styles["date-picker-icon"]}
                                        alt="location"
                                        style={{
                                            filter: 'brightness(0) saturate(100%) invert(99%) sepia(100%) saturate(3%) hue-rotate(144deg) brightness(102%) contrast(102%)',
                                            height: isMobile ? '' : '1.8rem', width: isMobile ? '' : '1.8rem'
                                        }}
                                    />
                                    <Typography className={styles["event-date"]}>
                                        Online - Zoom
                                    </Typography>
                                </Stack>

                                <Stack alignItems="center" columnGap={isMobile ? 1.5 : 1} direction="row">
                                    <img
                                        src={ImageAssets.link}
                                        className={styles["date-picker-icon"]}
                                        alt="zoom"
                                        style={{ height: isMobile ? '' : '1.8rem', width: isMobile ? '' : '1.8rem' }}
                                    />
                                    <Typography className={styles["event-meeting-link"]}>
                                        {eventData?.meetingLink || ''}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>


                        <div className={styles["line-break"]}></div>

                        {/* //event description */}
                        <Stack direction="column" rowGap={1}>
                            <Typography
                                style={
                                    screenSize.dynamicWidth < 840
                                        ? {
                                            fontSize: "1.4rem",
                                            fontWeight: "bold",
                                            color: "white",
                                        }
                                        : {
                                            fontSize: "1.6rem",
                                            fontWeight: "bold",
                                            color: "white",
                                        }
                                }
                            >
                                {strings.description}
                            </Typography>
                            <Typography
                                style={{ color: "var(--secondary-lite-grey-color)" }}
                                component="div"
                            >
                                <div
                                    dangerouslySetInnerHTML={{ __html: displayedHtml }}
                                />
                                {isLong && (
                                    <span
                                        onClick={() => setReadMore(!readMore)}
                                        style={{
                                            float: 'right',
                                            cursor: "pointer",
                                            color: "#79B9ED",
                                            textDecoration: "underline",
                                            // marginLeft: "5px",
                                        }}
                                    >
                                        {readMore ? "Read Less" : "Read More"}
                                    </span>
                                )}
                            </Typography>

                        </Stack>

                        <div className={styles["line-break"]}></div>

                        {/* //event slots and participants details */}
                        <div>
                            <Stack alignItems={'center'} gap={1} onClick={() => setExpand(!expand)}>
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={isMobile ? 19 : 30}
                                    thickness={8}
                                    sx={{
                                        color: '#666666', // Unfilled space color
                                        position: 'absolute',
                                    }}
                                />
                                <CircularProgress
                                    variant="determinate"
                                    value={(eventData?.noOfFilledSpots / eventData?.noOfTotalSpots) * 100}
                                    size={isMobile ? 19 : 30}
                                    thickness={8}
                                    sx={{
                                        color: '#95FFF6', // Filled space color
                                    }}
                                />
                                <Typography className={styles["event-text"]}>
                                    {eventData?.registeredUsers?.length > 0 ?
                                        `${eventData?.noOfFilledSpots} of ${eventData?.noOfTotalSpots} slots filled`
                                        : `${eventData?.noOfTotalSpots} slots available`
                                    }
                                </Typography>
                                <img
                                    src={expand ? ImageAssets.ic_up_dropdown : ImageAssets.ic_dropdownb}
                                    style={{ height: '2.5rem', width: '2.5rem', cursor: 'pointer' }}
                                    onClick={() => setExpand(!expand)}
                                />
                            </Stack>

                            <Stack flexDirection={'column'} gap={2} marginY={2}>
                                {eventData?.registeredUsers?.length > 0 ?
                                    eventData?.registeredUsers?.slice(0, 2)?.map((item) => <Stack gap={2} alignItems={'center'} className={styles["participants-container"]}
                                        onClick={() => handleProfileRedirection(item?.userId)}>
                                        <img src={item?.profilePic || ImageAssets.ic_dummy_profile} style={{ width: '4rem', height: '4rem', borderRadius: '50%', objectFit: 'cover' }} />
                                        <Stack flexDirection={'column'}>
                                            <Typography className={styles["userName"]}>
                                                {item?.userName}
                                            </Typography>
                                            <Typography className={styles["user-fullName"]}>
                                                {item?.fullName}
                                            </Typography>
                                        </Stack>
                                    </Stack>)
                                    :
                                    <Stack className={styles["participants-container"]}>
                                        <Typography className={styles["userName"]}>
                                            <span className={styles["user-fullName"]}>No artists here yet. </span>
                                            Be the first to Register and make your mark!
                                        </Typography>
                                    </Stack>
                                }
                            </Stack>

                            {expand ?
                                <Stack flexDirection={'column'} gap={2} marginY={2}>
                                    {eventData?.registeredUsers?.slice(2)?.map((item) => <Stack gap={2} alignItems={'center'} className={styles["participants-container"]}
                                        onClick={() => handleProfileRedirection(item?.userId)}>
                                        <img src={item?.profilePic || ImageAssets.ic_dummy_profile} style={{ width: '4rem', height: '4rem', borderRadius: '50%', objectFit: 'cover' }} />
                                        <Stack flexDirection={'column'}>
                                            <Typography className={styles["userName"]}>
                                                {item?.userName}
                                            </Typography>
                                            <Typography className={styles["user-fullName"]}>
                                                {item?.fullName}
                                            </Typography>
                                        </Stack>
                                    </Stack>)}
                                </Stack>
                                : ''
                            }
                        </div>

                        <div className={styles["line-break"]}></div>

                        {eventData?.eventType === "FREE" || eventData?.registeredUser ? null :
                            <>
                                {/* // Apply promo code section */}
                                <Stack flexDirection={"column"} gap={2} width={'100%'} alignItems={'left'}>
                                    {/* <Typography className={styles["event-date"]}>
                                        Woahhh!!!! Apply Promo Code and Get Amazing Discount
                                    </Typography> */}
                                    <Typography className={styles["event-text"]}>
                                        Apply Promo Code
                                    </Typography>
                                    <Stack gap={2} alignItems={'center'}>
                                        <input
                                            type={"text"}
                                            name="promoCode"
                                            placeholder={'Enter Promo Code'}
                                            className={promoCodeError ? `${styles.input} ${styles.error}` : promoCodeVerified ? `${styles.input} ${styles.success}` : styles.input}
                                            value={promoCode}
                                            onChange={(e: any) => setPromoCode(e.target.value)}
                                            disabled={promoCodeVerified ? true : false}
                                        />

                                        {/* <MuiTextField
                                                type="text"
                                                name="promoCode"
                                                label={"Enter Promo Code"}
                                                value={promoCode}
                                                onChange={(e: any) => setPromoCode(e.target.value)}
                                                errormessage=""
                                                shouldDisplayError={true}
                                                helpermessage={''}
                                                disabled={promoCodeVerified ? true : false}
                                            /> */}
                                        <Typography style={{ cursor: 'pointer', color: '#79B9ED' }} onClick={handleVerifyPromoCode}>Done</Typography>
                                        {/* <img src={ImageAssets.ic_checkbox_checked} style={{ height: '4.8rem', cursor: 'pointer' }} onClick={handleVerifyPromoCode} /> */}
                                    </Stack>
                                </Stack>

                                <div className={styles["line-break"]}></div>
                            </>
                        }
                    </Stack>

                    <Stack justifyContent={'center'} gap={2} marginTop={2}>
                        {/* Global condition: slots filled & not registered */}
                        {eventData?.registeredUser === false &&
                            eventData?.noOfFilledSpots === eventData?.noOfTotalSpots ? (
                            <MuiButton
                                className={styles["filled-button"]}
                                disabled
                            >
                                Slots Filled
                            </MuiButton>
                        ) : showRegister ? (
                            <>
                                {eventData?.registeredUser ? (
                                    <MuiButton
                                        className={styles["registered-button"]}
                                        disabled
                                    >
                                        Registered
                                    </MuiButton>
                                ) : (
                                    <MuiButton
                                        className={styles["pay-button"]}
                                        onClick={handleRegister}
                                    >
                                        Register
                                    </MuiButton>
                                )}
                            </>
                        ) : (
                            <>
                                {eventData?.appliedRefund && eventData?.registeredUser ? (
                                    <MuiButton
                                        className={styles["registered-button"]}
                                        disabled
                                    >
                                        Slot Cancelled
                                    </MuiButton>
                                ) : eventData?.registeredUser ? (
                                    <>
                                        <MuiButton
                                            className={styles["refund-button"]}
                                            onClick={() => setRefundPopup(true)}
                                        >
                                            Get Refund
                                        </MuiButton>
                                        <MuiButton
                                            className={styles["registered-button"]}
                                            disabled
                                        >
                                            Registered
                                        </MuiButton>
                                    </>
                                ) : (
                                    <MuiButton
                                        className={styles["pay-button"]}
                                        onClick={handlePayBtn}
                                    >
                                        Pay ₹{promoCodeVerified ? promoCodeAmount : eventData?.amount ?? 0}
                                    </MuiButton>
                                )}
                            </>
                        )}
                    </Stack>

                </div>
            </div>
            {refundPopup && <RefundPolicy open={refundPopup} onClose={() => {
                setRefundPopup(false)
                setInfoPopup(false)
            }} handleRefundBtn={handleRefundBtn} infoPopup={infoPopup} />}
            {showRefundPopup ? (
                <CustomSuccessDailog
                    varient={DailogBoxTypeEnum.successDailog}
                    open={showRefundPopup}
                    successIcon={ImageAssets.ic_error_cross}
                    handleDailogClose={handleCloseRefundPopup}
                >
                    <Typography variant="h2" className="success-message">
                        Registration failed, you will get refund in 3-5days.
                    </Typography>
                </CustomSuccessDailog>
            ) : null}
        </>
    );
};

export default EventDetailsPage;
